class MainMenu {
  constructor(component) {
    this.component = component;
    this.topMenuItems = this.component.querySelectorAll(
      '.main-nav > .main-menu > li > a',
    );
    // this.menuItems = this.component.querySelectorAll('.main-menu__item');
    this.mobileNavToggle = this.component.querySelectorAll('.mobile-nav');
    this.menuLinks = this.component.querySelectorAll('.main-menu__link');
    // this.subMenus = this.component.querySelectorAll('.sub-menu-wrap');
    this.init();
  }

  init = () => {
    // Identify the top level items so they can be treated differently
    this.topMenuItems.forEach((item) => {
      item.classList.add('top');
    });
    // Add Event Listeners
    this.menuLinks.forEach((link) => {
      link.addEventListener('click', this.onLinkClick);
    });
    this.mobileNavToggle.forEach((button) => {
      button.addEventListener('click', () => {
        this.component.classList.toggle('mobile-nav-open');
      });
    });
  };

  closeAll = () => {
    // Remove .active from everything
    const activeItems = this.component.querySelectorAll('.active');
    activeItems.forEach((item) => {
      item.classList.remove('active');
    });
  };

  closeSiblings = (link) => {
    // Traverse UP to <ul>, remove .active from ALL children elements IF they don’t have the class of .top
    const activeItems = link.parentElement.parentElement.querySelectorAll(
      '.active',
    );
    activeItems.forEach((item) => {
      item.classList.remove('active');
    });
  };

  toggleSubMenu = (link) => {
    // Traverse UP ONE LEVEL to parent, then find FIRST .sub-menu-wrap and add .active class
    const ul = link.parentElement;
    link.classList.toggle('active');
    ul.querySelector('.sub-menu-wrap').classList.toggle('active');
    const ariaExpanded = link.getAttribute('aria-expanded');
    if (ariaExpanded === 'true') {
      link.setAttribute('aria-expanded', 'false');
    } else {
      link.setAttribute('aria-expanded', 'true');
    }
  };

  onLinkClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const link = e.currentTarget;
    let openMenu = true;
    // Handle sub-menus if present, otherwise just follow the link
    if (link.classList.contains('main-menu__link--with-sub')) {
      if (link.classList.contains('active')) {
        openMenu = false;
        this.toggleSubMenu(link);
      } else if (link.classList.contains('top')) {
        this.closeAll();
      } else {
        this.closeSiblings(link);
      }
      if (openMenu) {
        this.toggleSubMenu(link);
      }
    } else if (link.classList.contains('main-menu__link--back')) {
      let parentMenu =
        link.parentElement.parentElement.parentElement.parentElement;
      parentMenu = parentMenu.parentElement.parentElement.querySelector(
        'button',
      );
      this.toggleSubMenu(parentMenu);
    } else {
      window.location.href = link.href;
    }
  };
}

Drupal.behaviors.mainMenu = {
  attach(context) {
    const mainMenu = context.querySelectorAll('.main-nav');
    mainMenu.forEach((menu) => new MainMenu(menu));
  },
};
